import React, {Component} from 'react';
import {Modal, ModalHeader} from 'reactstrap';
import {withTranslation} from 'react-i18next';
import {AddAdAccountForm} from "./AddAdAccountForm";
import {SheetLogo} from "../../logos/SheetLogo";

class AddAdAccountModalComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
        };

        this.toggle = this.toggle.bind(this);
        this.afterSuccessfulSubmit = this.afterSuccessfulSubmit.bind(this);
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    afterSuccessfulSubmit(newSheetAdAccountData) {
        this.toggle();
        this.props.afterSuccessfulSubmit(newSheetAdAccountData);
    }

    render() {
        const {t} = this.props;
        return (
            <Modal isOpen={this.state.modal}
                   toggle={this.toggle}
                   className={"sheet-import-modal " + (this.props.className || "")}
                   backdrop="static">
                <ModalHeader toggle={this.toggle}>
                    <SheetLogo/>&nbsp;{t('sheet_account.add_modal_title')}
                </ModalHeader>
                <AddAdAccountForm afterSuccessfulSubmit={this.afterSuccessfulSubmit}
                                  clientId={this.props.clientId}
                                  clientName={this.props.clientName}/>
            </Modal>
        );
    }
}

// `withRef`: `AddClientAdAccountForm` guarda la instancia por `ref` y abre el modal llamando
// `.toggle()`. Sin esta opción el HOC devuelve un componente de función y el ref llega vacío (el
// modal no abriría más). Mismo patrón que `panel_v11/LineEditDrawer`.
export const AddAdAccountModal = withTranslation(undefined, {withRef: true})(AddAdAccountModalComponent);
